import { Skeleton } from '@repo/ui/skeleton';
import { cn } from '@repo/utils/cn';

type InlineItemsSkeletonProps = {
  className?: string;
  itemClassName?: string;
  itemsCount?: number;
};

const InlineItemsSkeleton = ({ className, itemClassName, itemsCount = 3 }: InlineItemsSkeletonProps) => {
  return (
    <div className={cn('flex w-full space-x-1.5 py-2 rtl:space-x-reverse', className)}>
      {Array.from({ length: itemsCount }, (_, i) => (
        <Skeleton
          key={i}
          className={cn('h-7 rounded px-10 vt-tab-item-primary-bg', itemClassName)}
        />
      ))}
    </div>
  );
};

export default InlineItemsSkeleton;
